import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SimService } from '../sim.service';
import { normalizeMsisdn } from '../sim.utils';

@Component({
  selector: 'mprd-sim-replace',
  templateUrl: './sim-replace.component.html',
})
export class SimReplaceComponent {
  msisdn: string;

  constructor(
    private route: ActivatedRoute,
    private simService: SimService,
  ) {
    this.msisdn = normalizeMsisdn(this.route.snapshot.params.msisdn);
  }

  onReplaceWithEsim(): void {
    this.simService.navigateToEshareEsimPage(this.msisdn);
  }
}
